import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pinned = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pinned icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M5.5 7.48199C4.67157 7.48199 4 8.15357 4 8.98199C4 9.81042 4.67157 10.482 5.5 10.482H8.063C8.02187 10.6418 7.99999 10.8093 7.99999 10.982V15.6155C7.99999 16.1683 7.77118 16.6965 7.36787 17.0746L3.68967 20.5229C2.36697 21.763 3.24448 23.982 5.05755 23.982H18.9424C20.7555 23.982 21.633 21.763 20.3103 20.5229L16.6321 17.0746C16.2288 16.6965 16 16.1683 16 15.6155V10.982C16 10.8093 15.9781 10.6418 15.937 10.482H18.5C19.3284 10.482 20 9.81042 20 8.98199C20 8.15357 19.3284 7.48199 18.5 7.48199H5.5Z"
    />
  </svg>
)
